export default __webpack_public_path__ + "67e7ce07307c681fb49dc309c72a20a0.ttf";